// extracted by mini-css-extract-plugin
export default {"page":"NotFound_page__YiZAa","code":"NotFound_code__7APch"};